import type { TypeChatMessage } from '@/types/conversation/types.conversation.chat.message';

type Listener = (message: TypeChatMessage) => void;

const listeners = new Set<Listener>();

export const emitChatIncoming = (message: TypeChatMessage): void => {
    listeners.forEach((listener) => {
        try {
            listener(message);
        } catch {
            return;
        }
    });
};

export const onChatIncoming = (listener: Listener): (() => void) => {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
};
